import { CompanySiteOptionType } from '../../../../common';
import {
  getLabelMatchesSearch,
  getShouldShowAddCompanyOption,
  getShouldShowAddCompanySiteOption,
} from './helpers';

export type UseGetFilteredOptionsReturnType = {
  filteredOptions: CompanySiteOptionType[];
  shouldShowAddCompany: boolean;
  shouldShowAddCompanySite: boolean;
  singleCompanyId: string | null;
};

export const getFilteredOptions = (
  companySiteOptions: CompanySiteOptionType[],
  search: string
): UseGetFilteredOptionsReturnType => {
  const filteredOptions = companySiteOptions.filter((option) =>
    getLabelMatchesSearch(option.label, search)
  );

  const allCompanyNames = filteredOptions.map((option) => option.companyName);

  const shouldShowAddCompany = getShouldShowAddCompanyOption(filteredOptions);

  const shouldShowAddCompanySite =
    getShouldShowAddCompanySiteOption(allCompanyNames);

  const singleCompanyId =
    shouldShowAddCompanySite && filteredOptions[0]?.companyId !== undefined
      ? filteredOptions[0].companyId
      : null;

  return {
    filteredOptions,
    shouldShowAddCompany,
    shouldShowAddCompanySite,
    singleCompanyId,
  };
};
